
define('app/board/collections/pickCollection',[
	'jquery',
	'underscore',
	'backbone',
	'app/board/models/pickModel'
], function($, _, Backbone, PickModel){
	var PickCollection = Backbone.Collection.extend({
		model : PickModel,
		leagueId : null, //Populate this on construction
		leagueInstanceId : null, //Populate this on construction
		
		initialize: function(models, options) {
			this.leagueId = options.leagueId;
			this.leagueInstanceId = options.leagueInstanceId;
	    },
		
		url: function() {
			return '/draftapp/leagues/' + this.leagueId + '/league-instances/' + this.leagueInstanceId + '/picks';
		},
		
		getPickByPosRound : function(round, posInRound) {
			return this.findWhere({round: round, posInRound: posInRound});
		},
		
		getPicksByRound : function(round) {
			var foundPicks = this.filter(function(pick) {
				return pick.get('round') == round;
			});
			
			return _.sortBy(foundPicks, function(pick){ return pick.getPosRoundSortValue(); }, this);
		},
		
		getPicksByTeam : function(teamId) {
			var foundPicks = this.filter(function(pick) {;
				return pick.get('fantasyTeamId') == teamId;
			});
		
			return _.sortBy(foundPicks, function(pick){ return pick.getPosRoundSortValue(); }, this);
		},
		
		saveChanges: function(successCallback, errorCallback) {
			var dataJson = this.toJSON();
			
			$.ajax({
				headers : {
					"Content-Type" : "application/json",
					"Accept" : "application/json"
				},
				url : 
					'/draftapp/leagues/' 
					+ this.leagueId 
					+ '/league-instances/' 
					+ this.leagueInstanceId 
					+ '/picks',
				type : 'PUT',
				dataType : 'json',
				//accepts: 'application/json',
				//contentType: 'application/json',
				data : JSON.stringify(dataJson, null, 2),
				success: successCallback,
				error: errorCallback
				/*success: function(data, status) {
					$("#chatTextInput").val('');
				},
				error: function(data, status) {
					$("#chatTextInput").val('');
				}*/
			});
		}
	    
	});
	
	return PickCollection;  
});